import { render } from "./AnswerSlider.vue?vue&type=template&id=6ec4c7d1&scoped=true"
import script from "./AnswerSlider.vue?vue&type=script&lang=js"
export * from "./AnswerSlider.vue?vue&type=script&lang=js"

import "./AnswerSlider.vue?vue&type=style&index=0&id=6ec4c7d1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec4c7d1"]])

export default __exports__